import { Component } from 'react';
import {
    map
} from 'lodash';

import DescriptorValue from 'common/components/DescriptorValue/DescriptorValue';
import ValueTags from 'common/components/ValueTags/ValueTags';
import styles from './ValueList.scss';

class ValueList extends Component {
    _getFormattedValues() {
        const {
            value=[],
            dataType
        } = this.props;

        return map(value, (valueText) =>
            <DescriptorValue
                dataType={dataType}
                value={valueText} />
        );
    }

    render() {
        return (
            <div className={styles.values} data-cy="valueList">
                <ValueTags
                    values={this._getFormattedValues()}
                    isReadOnly={true} />
            </div>
        );
    }
}

export default ValueList;
